import React from "react";
import ShowDatePicker from "./ShowDatePicker";
import TimeOfPerformance from "./TimeOfPerformance";
import { ShowDates } from "./models";

interface ShowDateAndTimePickerProps {
  timePickerPlacehoder?: string
  showDates: ShowDates
  onChange: (showDates: ShowDates) => void
}

export const ShowDateAndTimePicker = (props: ShowDateAndTimePickerProps) => {
  return <div>
    <ShowDatePicker
      compact
      validatorKey="showDates"
      dates={props.showDates}
      onDatesChanged={props.onChange}
    />

    {props.showDates.mode === "allDay" && <TimeOfPerformance
      placeholder={props.timePickerPlacehoder}
      showDates={props.showDates}
      onTimeOfPerformanceChanged={time => props.onChange({ ...props.showDates, timeOfPerformance: time })}
    />}
  </div>
}